import * as React from 'react';

import { useTranslation } from 'react-i18next';

import intro_pic from '@assets/images/welcome/intro.png';
import rockets_intro_pic from '@assets/images/welcome/rockets_intro.png';

const isRockets = config.BRAND === 'rockets';

import { Button } from '@components/button';

import { config } from '@/config.ts';

import * as Styled from './intro.styled.ts';

type OwnProps = {
	onClickNext: () => void;
};

const Intro: React.FC<OwnProps> = ({ onClickNext }) => {
	const { t } = useTranslation(['welcome', 'main']);

	return (
		<Styled.Wrapper $isReverse={isRockets}>
			<Styled.Content>
				<Styled.Title>
					{isRockets ? (
						<>
							{t('rockets_intro1')}
							<span>Parik24</span>{' '}
						</>
					) : (
						<>
							<span>PM-Pass</span> {t('intro_title')}
						</>
					)}
				</Styled.Title>
				<Styled.Info>
					<Styled.Text
						dangerouslySetInnerHTML={{
							__html: isRockets ? t('rockets_intro1_description') : t('intro_text2')
						}}
					/>
				</Styled.Info>
				<Button onClick={onClickNext} color='primary'>
					{isRockets ? t('rockets_intro_button') : t('main:next')}
				</Button>
			</Styled.Content>
			<Styled.IntroPic src={isRockets ? rockets_intro_pic : intro_pic} alt='intro' />
		</Styled.Wrapper>
	);
};

export default Intro;
